import axios from "axios";
import { API_ORIGIN } from "../config/constants";

const authToken = localStorage.getItem("Authtoken");

export class ProductReviewService {
  static productReviewDetailsSearch = async (rowsPerPage, page, status, productId) => {
    try {
      let filter = [];
      if(status){
          filter.push({"status": status});
      }

      if(productId){
        filter.push({"productId": productId});
      }

      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/product-reviews/admin/search",
        data: {
          filter: filter,
          limit: rowsPerPage,
          skip: page * rowsPerPage,
          sort: "DESC",
        },
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      let productReviewDetail = response.data.data;
      return productReviewDetail;
    } catch (err) {
      throw err;
    }
  };

  static productReviewDetailsID = async (priceID) => {
    try {
      let response = await axios({
        method: "get",
        baseURL: API_ORIGIN + "/product-reviews/" + priceID,
        headers: { Authorization: `Bearer ${authToken}` },
      });

      let productReviewDetailID = response.data.data;

      return productReviewDetailID;
    } catch (err) {
      throw err;
    }
  };

  static productReviewDelete = async (reviewID) => {
    try {
      let response = await axios({
        method: "delete",
        baseURL: API_ORIGIN + "/product-reviews/admin/delete/" + reviewID,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

  static productReviewStatusUpdate = async (reviewID, status) => {
    try {
      let response = await axios({
        method: "put",
        baseURL: API_ORIGIN + "/product-reviews/admin/update/status/" + reviewID,
        data: status,
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

}
